var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-editor',{ref:"editor",attrs:{"options":_vm.options,"propValue":_vm.propValue,"dataId":_vm.dataId,"propReadonly":_vm.readonly,"validateArg":_vm.validateArg},on:{"change":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }